import { Table, TableBody, TableCell, TableCellProps, TableHead, TableRow } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { addNumberDotSeparator } from '../../../../util/addNumberDotSeparator'

interface Props {
  title: string
  successful: number,
  failure: number
  pending: number
  type: 'general' | 'awaiting'
}

const BorderlessTableCell: React.FC<TableCellProps> = (props) => {
  return (
    <TableCell {...props} style={{ ...props.style, borderBottom: 0 }}/>
  )
}

const DashboardNetworkContentPostDetailsTable: React.FC<Props> = (props) => {
  const { t } = useTranslation()

  return (
    <Table size={'small'} sx={{ maxWidth: 250, paddingTop: 0 }} title={`${t('coreCalendar:publications')}:`}>
      <TableHead>
        <TableRow>
          <BorderlessTableCell
            style={{ paddingLeft: 0 }}
            size="small"
            colSpan={2}
          >
            <strong>{props.title}</strong>
          </BorderlessTableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <BorderlessTableCell style={{ paddingLeft: 0 }} width="auto" size="small">
            {(props.type === 'general' ? t('coreCalendar:deferredPostPending') : t('coreCalendar:deferredPostStatusAwaitingUserConfirmationLower')) + ':'}
          </BorderlessTableCell>
          <BorderlessTableCell align="left" size="small">
            {addNumberDotSeparator(props.pending)}
          </BorderlessTableCell>
        </TableRow>
        <TableRow>
          <BorderlessTableCell style={{ paddingLeft: 0 }} width="auto" size="small">
            {t('coreDashboard:Successful')}:
          </BorderlessTableCell>
          <BorderlessTableCell align="left" size="small">
            {addNumberDotSeparator(props.successful)}
          </BorderlessTableCell>
        </TableRow>
        <TableRow>
          <BorderlessTableCell style={{ paddingLeft: 0, borderBottom: 0 }} size="small">
            {t('coreDashboard:Failed')}:
          </BorderlessTableCell>
          <BorderlessTableCell width="auto" align="left" size="small">
            {addNumberDotSeparator(props.failure)}
          </BorderlessTableCell>
        </TableRow>
      </TableBody>
    </Table>
  )
}
export default DashboardNetworkContentPostDetailsTable
